import CustomStore from "devextreme/data/custom_store";
import DataGrid, {
  Editing,
  SearchPanel,
  // Toolbar,
  // Item,
  Export,
} from "devextreme-react/data-grid";
import ScrollView from "devextreme-react/scroll-view";
import safeAwait from "safe-await";
import { useRef, useState } from "react";
import { Toast } from "devextreme-react/toast";
import { useEffectOnce } from "react-use";

const DataGridView = ({
  access,
  insert,
  update,
  remove,
  load,
  onSaving,  
  onEditingStart,
  children,
  editingMode = "form",
  onLoadComplete,
}) => {
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const dataGrid = useRef(null);
  const [store, setStore] = useState();
  const handleError = (error) => {
    setShow(true);
    setMessage(error.response.data.message);
    throw new Error("Network Error");
  };
  useEffectOnce(() => {
    const SalaryPeriodeStore = new CustomStore({
      key: "id",
      loadMode: "raw",
      load: async () => {
        const [error, data] = await safeAwait(load());
        if (error) handleError(error);
        onLoadComplete(data);
        return data;
      },
      insert: async (values) => {
        const [error, data] = await safeAwait(insert(values));
        if (error) handleError(error);
        return data;
      },
      update: async (key, values) => {
        const [error, data] = await safeAwait(update(key, values));
        if (error) handleError(error);
        return data;
      },
      remove: async (key) => {
        const [error, data] = await safeAwait(remove(key));
        if (error) handleError(error);
        return data;
      },
    });
    setStore(SalaryPeriodeStore);
  });

  return (
    <ScrollView>
      <Toast
        visible={show}
        message={message}
        type={"error"}
        displayTime={3000}
        onHiding={() => setShow(false)}
      />

      <DataGrid
        ref={dataGrid}
        dataSource={store}
        showBorders={true}
        useIcons={true}
        showEditorAlways={true}
        columnAutoWidth={true}
        activeStateEnabled={true}
        onSaving={onSaving}
        onEditingStart={onEditingStart}
        onExporting={() => {}}
      >
        <Editing
          mode={editingMode}
          allowAdding={access.includes("new")}
          allowDeleting={access.includes("delete")}
          allowUpdating={access.includes("edit")}
          useIcons={true}
        />
        <Export enabled={true} />
        <SearchPanel visible={true} width="100%" />
        {/* <Toolbar>
          <Item location="before" name="addRowButton" />
          <Item location="before" name="exportButton" />
        </Toolbar> */}
        {children}
      </DataGrid>
    </ScrollView>
  );
};

export default DataGridView;
